import React from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import { ShapeControlProps } from "./types";
import { ShapeControlButton } from "./ShapeControlButton";
import { useMapEditorActions } from "../../../../contexts/MapEditorContext";
import { useEditorShortcuts } from "../../../shortcuts/EditorShortcutContext/useEditorShortcuts";

export const ShapeControlLayerOrder: React.FC<ShapeControlProps> = ({
  shape,
}) => {
  const { moveShape } = useMapEditorActions();
  const { shortcuts } = useEditorShortcuts();
  return (
    <>
      <ShapeControlButton
        onClick={() => moveShape(shape.id, "up")}
        title={"Move to front"}
        icon={ArrowUp}
        shortcut={shortcuts.shapeSelection.moveToFront}
      />
      <ShapeControlButton
        onClick={() => moveShape(shape.id, "down")}
        title={"Move to back"}
        icon={ArrowDown}
        shortcut={shortcuts.shapeSelection.moveToBack}
      />
    </>
  );
};
